<app-spinner-overlay></app-spinner-overlay>

<div mat-dialog-content class="dialog-center-compilazione">
  <swiper-container
    [simulateTouch]="false"
    auto-height="true"
    #swiperAmbiti
    (swiperslidechange)="onSlideChange()"
  >
    @for (amb of ambiti; track $index) {
      <swiper-slide class="ambito">
        <div class="left-border">
          <div class="titolo-ambito space-left-title">
            Ambito - {{ amb.titolo }} - {{ amb.descrizione }}
          </div>
        </div>

        <swiper-container [simulateTouch]="false" auto-height="true" #swiperTematiche>
          @for (tematica of amb.tematiche; track $index) {
            <swiper-slide>
              <div class="tematiche">
                @if (tematica.domanda) {
                  <div class="left-border">
                    <div class="domanda space-left-title">Tematica - {{ tematica.domanda }}</div>
                  </div>
                }
                @if (tematica.descrizione) {
                  <div class="left-border">
                    <div class="descrizione-tematica space-left-title">
                      {{ tematica.descrizione }}
                    </div>
                  </div>
                }

                <div class="divisore"></div>

                @if (tematica.tipo === 'scelta_multipla_valore') {
                  @for (opz of tematica.risposteVsme; let idxOpz = $index; track $index) {
                    <div
                      class="checkbox-group"
                      [ngStyle]="{ 'margin-top': idxOpz > 0 ? '5px' : '0px' }"
                    >
                      <mat-checkbox
                        #checkboxOpz
                        [value]="opz.chiave"
                        [disabled]="readOnly || (!opz.moduloCompleto && isPMI)"
                        [checked]="tematica?.risposte?.includes(opz.chiave)"
                        (change)="cambioCheckOpzione($event, tematica, opz)"
                      >
                        @if (
                          opz.codiceNormaVsme || opz.descrizioneNormaVsme || !opz.moduloCompleto
                        ) {
                          <div style="display: inline">
                            <span class="titolo-checkbox f-w-400"> {{ opz.valore }}</span>
                            @if (opz.codiceNormaVsme || opz.descrizioneNormaVsme) {
                              <mat-icon
                                class="material-icons-outlined tooltip-info"
                                [appTooltipOverlay]="tooltipNormaTemplate"
                                [variabiliTemplate]="{
                                  codiceNormaVsme: opz.codiceNormaVsme,
                                  descrizioneNormaVsme: opz.descrizioneNormaVsme,
                                }"
                                position="right"
                              >
                                info
                              </mat-icon>
                            }
                            <!-- Icona locked (modulo base) -->
                            @if (!opz.moduloCompleto && isPMI) {
                              <mat-icon
                                class="material-icons-outlined icon-locked"
                                matTooltip="Modulo Base"
                              >
                                lock
                              </mat-icon>
                            }
                          </div>
                        } @else {
                          <span class="titolo-checkbox"> {{ opz.valore }}</span>
                        }

                        <!-- ICONA (MODULO COMPLETO) -->
                        @if (opz.moduloCompleto) {
                          <mat-icon
                            style="margin-left: 8px"
                            class="material-icons-outlined icon-m-completo"
                            matTooltip="Modulo Completo"
                          >
                            energy_savings_leaf
                          </mat-icon>
                        }
                      </mat-checkbox>
                      @if (opz.sottoOpzioni.length && checkboxOpz.checked) {
                        <div class="sotto-opzioni">
                          @for (sottoOpz of opz.sottoOpzioni; track $index) {
                            <div class="radio-group">
                              <!-- TABELLA -->
                              @if (sottoOpz.tipo === 'dynamic_table') {
                                <div class="checkbox-wrapper">
                                  <mat-checkbox
                                    #checkSottoOpzioneAttiva
                                    [checked]="sottoOpz.checked"
                                    [disabled]="readOnly || (!sottoOpz.moduloCompleto && isPMI)"
                                    (change)="sottoOpzAzioneKpiChecked($event, sottoOpz)"
                                  >
                                    <div style="display: inline">
                                      <span class="titolo-checkbox">
                                        {{
                                          sottoOpz.titoloTabella
                                            ? sottoOpz.titoloTabella
                                            : 'Compilazione Tabellare'
                                        }}
                                      </span>
                                      <!-- Icona locked (modulo base) -->
                                      @if (!sottoOpz.moduloCompleto && isPMI) {
                                        <mat-icon
                                          class="material-icons-outlined icon-locked"
                                          matTooltip="Modulo Base"
                                        >
                                          lock
                                        </mat-icon>
                                      }
                                      <!-- Icona (figura aziendale) -->
                                      <ng-container
                                        [ngTemplateOutlet]="iconaFiguraAziendale"
                                        [ngTemplateOutletContext]="{
                                          idAmbito: amb.id,
                                          idTematica: tematica.id,
                                          chiaveRisposta: opz.chiave,
                                          sottoRisposta: sottoOpz,
                                        }"
                                      ></ng-container>

                                      <!-- Icona (modulo completo) -->
                                      @if (sottoOpz.moduloCompleto && !opz.moduloCompleto) {
                                        <mat-icon
                                          class="material-icons-outlined icon-m-completo"
                                          matTooltip="Modulo Completo"
                                        >
                                          energy_savings_leaf
                                        </mat-icon>
                                      }
                                      <!-- Icona (prompt AI FOLLIA) -->
                                      @if (!readOnly) {
                                        <ng-container
                                          [ngTemplateOutlet]="iconaFolliaWidget"
                                          [ngTemplateOutletContext]="{
                                            tematica: tematica,
                                            sottoRisposta: sottoOpz,
                                          }"
                                        ></ng-container>
                                      }
                                    </div>
                                  </mat-checkbox>
                                </div>
                                @if (checkSottoOpzioneAttiva.checked) {
                                  <div
                                    class="cnt-sottoOpz"
                                    [style.--cnt-sottoOpz-bg]="
                                      sottoOpz.notRisposta ? '#ffe4000d' : '#0060800d'
                                    "
                                    [style.--cnt-sottoOpz-border]="
                                      sottoOpz.notRisposta ? '#fcd844' : '#0060808f'
                                    "
                                  >
                                    <!-- MOTIVAZIONE DI MANCATA RIPOSTA PER MODULO BASE -->
                                    @if (!sottoOpz.moduloCompleto && isPMI) {
                                      <ng-container
                                        [ngTemplateOutlet]="nonRispondo"
                                        [ngTemplateOutletContext]="{
                                          sottoRisposta: sottoOpz,
                                        }"
                                      >
                                      </ng-container>
                                    }

                                    @if (!sottoOpz.notRisposta) {
                                      <div class="cnt-risposta">
                                        <app-tabella-cfg-dinamica
                                          #cfgTabellaDinamica
                                          (variazioneDimensioneCelle)="renderizzaSwiper($event)"
                                          (tabellaChange)="aggiornaTabella($event, sottoOpz)"
                                          [tabella]="generaOggettoTabella(sottoOpz)"
                                          [disabilitaHeaderRC]="true"
                                          [disabilitaCelle]="readOnly"
                                          [nascondiBottoni]="readOnly"
                                        ></app-tabella-cfg-dinamica>
                                      </div>
                                    }
                                  </div>
                                }
                              }

                              <!-- CHECKBOX -->
                              @if (sottoOpz.tipo === 'checkbox') {
                                <div class="checkbox-wrapper">
                                  <mat-checkbox
                                    #checkSottoOpzioneAttiva
                                    [value]="sottoOpz.chiave"
                                    [disabled]="readOnly || (!sottoOpz.moduloCompleto && isPMI)"
                                    [checked]="sottoOpz.checked"
                                    (change)="sottoOpzAzioneKpiChecked($event, sottoOpz)"
                                  >
                                    <div style="display: inline">
                                      <span class="titolo-checkbox">
                                        {{ sottoOpz.valore }}
                                      </span>
                                      <!-- Icona locked (modulo base) -->
                                      @if (!sottoOpz.moduloCompleto && isPMI) {
                                        <mat-icon
                                          class="material-icons-outlined icon-locked"
                                          matTooltip="Modulo Base"
                                        >
                                          lock
                                        </mat-icon>
                                      }
                                      <!-- Icona (figura aziendale) -->
                                      <ng-container
                                        [ngTemplateOutlet]="iconaFiguraAziendale"
                                        [ngTemplateOutletContext]="{
                                          idAmbito: amb.id,
                                          idTematica: tematica.id,
                                          chiaveRisposta: opz.chiave,
                                          sottoRisposta: sottoOpz,
                                        }"
                                      >
                                      </ng-container>

                                      <!-- Icona (modulo completo) -->
                                      @if (sottoOpz.moduloCompleto && !opz.moduloCompleto) {
                                        <mat-icon
                                          class="material-icons-outlined icon-m-completo"
                                          matTooltip="Modulo Completo"
                                        >
                                          energy_savings_leaf
                                        </mat-icon>
                                      }
                                      <!-- Icona (prompt AI FOLLIA) -->
                                      @if (!readOnly) {
                                        <ng-container
                                          [ngTemplateOutlet]="iconaFolliaWidget"
                                          [ngTemplateOutletContext]="{
                                            tematica: tematica,
                                            sottoRisposta: sottoOpz,
                                          }"
                                        ></ng-container>
                                      }
                                    </div>
                                  </mat-checkbox>
                                </div>
                                @if (checkSottoOpzioneAttiva.checked) {
                                  <div
                                    class="cnt-sottoOpz"
                                    [style.--cnt-sottoOpz-bg]="
                                      sottoOpz.notRisposta ? '#ffe4000d' : '#0060800d'
                                    "
                                    [style.--cnt-sottoOpz-border]="
                                      sottoOpz.notRisposta ? '#fcd844' : '#0060808f'
                                    "
                                  >
                                    <!-- MOTIVAZIONE DI MANCATA RIPOSTA PER MODULO BASE -->
                                    @if (!sottoOpz.moduloCompleto && isPMI) {
                                      <ng-container
                                        [ngTemplateOutlet]="nonRispondo"
                                        [ngTemplateOutletContext]="{
                                          sottoRisposta: sottoOpz,
                                        }"
                                      >
                                      </ng-container>
                                    }

                                    @if (!sottoOpz.notRisposta) {
                                      <div appFormContainer [larghezza]="3" class="cnt-risposta">
                                        <mat-form-field [larghezza]="2" appFormElement>
                                          <mat-label>Risposta</mat-label>
                                          <textarea
                                            #textArea
                                            matInput
                                            [placeholder]="'Risposta'"
                                            rows="4"
                                            [disabled]="readOnly"
                                            [(ngModel)]="sottoOpz.risposta"
                                          ></textarea>
                                          <mat-error appFormError></mat-error>
                                        </mat-form-field>
                                      </div>
                                    }
                                  </div>
                                }
                              }

                              <!-- AZIONE -->
                              @if (sottoOpz.tipo === 'azione') {
                                <div class="checkbox-wrapper">
                                  <mat-checkbox
                                    #checkSottoOpzioneAttiva
                                    [checked]="sottoOpz.checked"
                                    [disabled]="readOnly || (!sottoOpz.moduloCompleto && isPMI)"
                                    (change)="sottoOpzAzioneKpiChecked($event, sottoOpz)"
                                  >
                                    <div style="display: inline">
                                      <span class="titolo-checkbox">
                                        {{ sottoOpz.titolo }}
                                      </span>

                                      <!-- Icona locked (modulo base) -->
                                      @if (!sottoOpz.moduloCompleto && isPMI) {
                                        <mat-icon
                                          class="material-icons-outlined icon-locked"
                                          matTooltip="Modulo Base"
                                        >
                                          lock
                                        </mat-icon>
                                      }
                                      <!-- Icona (figura aziendale) -->
                                      <ng-container
                                        [ngTemplateOutlet]="iconaFiguraAziendale"
                                        [ngTemplateOutletContext]="{
                                          idAmbito: amb.id,
                                          idTematica: tematica.id,
                                          chiaveRisposta: opz.chiave,
                                          sottoRisposta: sottoOpz,
                                        }"
                                      >
                                      </ng-container>

                                      <!-- Icona (modulo completo) -->
                                      @if (sottoOpz.moduloCompleto && !opz.moduloCompleto) {
                                        <mat-icon
                                          class="material-icons-outlined icon-m-completo"
                                          matTooltip="Modulo Completo"
                                        >
                                          energy_savings_leaf
                                        </mat-icon>
                                      }

                                      <!-- CONSIGLIATO - elemento consigliato -->
                                      @if (sottoOpz.preCompilazioneInfos) {
                                        <button
                                          mat-icon-button
                                          class="material-icons-outlined icon-m-completo"
                                          [matTooltip]="
                                            'Azione e buona pratica consigliata, vedi maggiori informazioni'
                                          "
                                          (click)="
                                            $event.stopPropagation();
                                            apriPopUpConsigliato(sottoOpz, 'azione')
                                          "
                                        >
                                          <span class="material-icons-outlined">
                                            emoji_objects
                                          </span>
                                        </button>
                                      }
                                      <!-- Icona (prompt AI FOLLIA) -->
                                      @if (!readOnly) {
                                        <ng-container
                                          [ngTemplateOutlet]="iconaFolliaWidget"
                                          [ngTemplateOutletContext]="{
                                            tematica: tematica,
                                            sottoRisposta: sottoOpz,
                                          }"
                                        ></ng-container>
                                      }
                                    </div>
                                  </mat-checkbox>
                                </div>

                                <mat-label class="descrizione-checkbox pad-botm-15">{{
                                  sottoOpz.descrizione
                                }}</mat-label>
                                @if (checkSottoOpzioneAttiva.checked) {
                                  <div
                                    class="cnt-sottoOpz"
                                    [style.--cnt-sottoOpz-bg]="
                                      sottoOpz.notRisposta ? '#ffe4000d' : '#0060800d'
                                    "
                                    [style.--cnt-sottoOpz-border]="
                                      sottoOpz.notRisposta ? '#fcd844' : '#0060808f'
                                    "
                                  >
                                    <!-- MOTIVAZIONE DI MANCATA RIPOSTA PER MODULO BASE -->
                                    @if (!sottoOpz.moduloCompleto && isPMI) {
                                      <ng-container
                                        [ngTemplateOutlet]="nonRispondo"
                                        [ngTemplateOutletContext]="{
                                          sottoRisposta: sottoOpz,
                                        }"
                                      >
                                      </ng-container>
                                    }
                                    @if (!sottoOpz.notRisposta) {
                                      <div appFormContainer [larghezza]="3" class="cnt-risposta">
                                        <mat-form-field [larghezza]="2" appFormElement>
                                          <mat-label>Risposta</mat-label>
                                          <textarea
                                            matInput
                                            #textArea
                                            [placeholder]="'Risposta'"
                                            rows="4"
                                            [disabled]="readOnly"
                                            [(ngModel)]="sottoOpz.risposta"
                                          ></textarea>
                                          <mat-error appFormError></mat-error>
                                        </mat-form-field>
                                        @if (sottoOpz.preCompilazioneInfos) {
                                          <mat-icon
                                            class="material-icons-outlined icona-pre-sel-info"
                                            style="padding-top: 55px"
                                            [matTooltip]="getTooltip(sottoOpz.preCompilazioneInfos)"
                                          >
                                            info
                                          </mat-icon>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              }

                              <!-- KPI -->
                              @if (sottoOpz.tipo === 'kpi') {
                                <div class="checkbox-wrapper">
                                  <mat-checkbox
                                    #checkSottoOpzioneAttiva
                                    [checked]="sottoOpz.checked"
                                    [disabled]="readOnly || (!sottoOpz.moduloCompleto && isPMI)"
                                    (change)="sottoOpzAzioneKpiChecked($event, sottoOpz)"
                                  >
                                    <div style="display: inline">
                                      <span class="titolo-checkbox">
                                        {{ sottoOpz.nomeBreve }}
                                      </span>
                                      <!-- Icona locked (modulo base) -->
                                      @if (!sottoOpz.moduloCompleto && isPMI) {
                                        <mat-icon
                                          class="material-icons-outlined icon-locked"
                                          matTooltip="Modulo Base"
                                        >
                                          lock
                                        </mat-icon>
                                      }

                                      <!-- Icona (figura aziendale) -->
                                      <ng-container
                                        [ngTemplateOutlet]="iconaFiguraAziendale"
                                        [ngTemplateOutletContext]="{
                                          idAmbito: amb.id,
                                          idTematica: tematica.id,
                                          chiaveRisposta: opz.chiave,
                                          sottoRisposta: sottoOpz,
                                        }"
                                      >
                                      </ng-container>

                                      <!-- Icona (modulo completo) -->
                                      @if (sottoOpz.moduloCompleto && !opz.moduloCompleto) {
                                        <mat-icon
                                          class="material-icons-outlined icon-m-completo"
                                          matTooltip="Modulo Completo"
                                        >
                                          energy_savings_leaf
                                        </mat-icon>
                                      }

                                      <!-- CONSIGLIATO - elemento consigliato -->
                                      @if (sottoOpz.valoriKpi[0].preCompilazioneInfos) {
                                        <button
                                          mat-icon-button
                                          class="material-icons-outlined icon-m-completo"
                                          [matTooltip]="
                                            'KPI consigliato, vedi maggiori informazioni'
                                          "
                                          (click)="
                                            $event.stopPropagation();
                                            apriPopUpConsigliato(sottoOpz, 'kpi')
                                          "
                                        >
                                          <span class="material-icons-outlined">
                                            emoji_objects
                                          </span>
                                        </button>
                                      }
                                      <!-- Icona (prompt AI FOLLIA) -->
                                      @if (!readOnly) {
                                        <ng-container
                                          [ngTemplateOutlet]="iconaFolliaWidget"
                                          [ngTemplateOutletContext]="{
                                            tematica: tematica,
                                            sottoRisposta: sottoOpz,
                                          }"
                                        ></ng-container>
                                      }
                                    </div>
                                  </mat-checkbox>
                                </div>

                                <mat-label class="descrizione-checkbox pad-botm-15">{{
                                  sottoOpz.descrizione
                                }}</mat-label>

                                @if (checkSottoOpzioneAttiva.checked) {
                                  <div
                                    class="cnt-sottoOpz"
                                    [style.--cnt-sottoOpz-bg]="
                                      sottoOpz.notRisposta ? '#ffe4000d' : '#0060800d'
                                    "
                                    [style.--cnt-sottoOpz-border]="
                                      sottoOpz.notRisposta ? '#fcd844' : '#0060808f'
                                    "
                                  >
                                    <!-- MOTIVAZIONE DI MANCATA RIPOSTA PER MODULO BASE -->
                                    @if (!sottoOpz.moduloCompleto && isPMI) {
                                      <ng-container
                                        [ngTemplateOutlet]="nonRispondo"
                                        [ngTemplateOutletContext]="{
                                          sottoRisposta: sottoOpz,
                                        }"
                                      >
                                      </ng-container>
                                    }
                                    @if (!sottoOpz.notRisposta) {
                                      <div appFormContainer [larghezza]="3" class="cnt-risposta">
                                        <mat-form-field appFormElement [larghezza]="1">
                                          <mat-label>Unità di Misura</mat-label>
                                          <mat-select
                                            [placeholder]="'Unità di Misura'"
                                            [disabled]="readOnly"
                                            [(ngModel)]="sottoOpz.valoriKpi[0].idUnitaDiRiferimento"
                                          >
                                            @for (
                                              um of arrayUm[
                                                sottoOpz.valoriKpi[0].idCategoriaUnitaDiMisura
                                              ];
                                              track $index
                                            ) {
                                              <mat-option [value]="um.id">{{
                                                um.descrizione
                                              }}</mat-option>
                                            }
                                          </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appFormElement [larghezza]="1">
                                          <mat-label>Risposta</mat-label>
                                          <input
                                            matInput
                                            [placeholder]="'Risposta'"
                                            [disabled]="readOnly"
                                            [(ngModel)]="sottoOpz.valoriKpi[0].valoreAttribuito"
                                            type="number"
                                            appInputNumber
                                            step="0.01"
                                            inputmode="numeric"
                                          />
                                          <mat-error appFormError></mat-error>
                                        </mat-form-field>
                                        <!-- Icona (modulo completo) -->
                                        @if (sottoOpz.valoriKpi[0].preCompilazioneInfos) {
                                          <mat-icon
                                            class="material-icons-outlined icona-pre-sel-info"
                                            [matTooltip]="
                                              getTooltip(sottoOpz.valoriKpi[0].preCompilazioneInfos)
                                            "
                                          >
                                            info
                                          </mat-icon>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            </swiper-slide>
          }
        </swiper-container>
      </swiper-slide>
    }
  </swiper-container>
</div>

<!-- FIGURA AZIENDALE DI ASSEGNAMENTO -->
<ng-template
  #iconaFiguraAziendale
  let-idAmbito="idAmbito"
  let-idTematica="idTematica"
  let-chiaveRisposta="chiaveRisposta"
  let-sottoRisposta="sottoRisposta"
>
  @if (sottoRisposta.checked) {
    <button
      mat-icon-button
      aria-label="Associa Figura Aziendale"
      class="icona-figura"
      [disabled]="readOnly"
      [matTooltip]="toolTipFigura(sottoRisposta?.figura)"
      style="vertical-align: middle"
      (click)="
        $event.stopPropagation();
        associaFiguraAziendale(
          idAmbito,
          idTematica,
          chiaveRisposta,
          sottoRisposta,
          sottoRisposta?.figura
        )
      "
    >
      <mat-icon
        class="material-icons-outlined"
        [ngClass]="{
          'blue-icon': sottoRisposta?.figura?.id,
          'default-icon': !sottoRisposta?.figura?.id,
        }"
      >
        person
      </mat-icon>
    </button>
  }
</ng-template>

<ng-template
  #tooltipNormaTemplate
  let-codiceNormaVsme="codiceNormaVsme"
  let-descrizioneNormaVsme="descrizioneNormaVsme"
>
  <div>
    <span style="font-weight: 500"
      >{{ codiceNormaVsme }} -
      <span style="font-size: 12px; font-weight: normal !important">{{
        descrizioneNormaVsme
      }}</span></span
    >
  </div>
</ng-template>

<!-- FOLLIA WIDGET -->
<ng-template #iconaFolliaWidget let-tematica="tematica" let-sottoRisposta="sottoRisposta">
  @if (sottoRisposta.checked && isIntegrazioneAI) {
    <app-follia-icon-for-element
      [elemento]="getElementoForAI(sottoRisposta)"
      [tipoElemento]="getTipoElemento(sottoRisposta.tipo)"
      [tematica]="getElementoForAITematica(tematica)"
    ></app-follia-icon-for-element>
  }
</ng-template>

<!-- MOTIVAZIONE DI MANCATA RIPOSTA PER MODULO BASE -->
<ng-template #nonRispondo let-sottoRisposta="sottoRisposta">
  <div class="giustifica-risposta">
    <mat-slide-toggle
      [(ngModel)]="sottoRisposta.notRisposta"
      labelPosition="before"
      [disabled]="readOnly"
    >
      Non ho una risposta!</mat-slide-toggle
    >
  </div>

  @if (sottoRisposta.notRisposta) {
    <app-motivazione-risposta-vsme
      [sottoRisposta]="sottoRisposta"
      [readOnly]="readOnly"
      [isPMI]="isPMI"
      (motivazioneChanged)="motivazioneChanged($event)"
    ></app-motivazione-risposta-vsme>
  }
</ng-template>
